<template>
  <Layout footer>
    <div class="app-container text-base pb-16">
      <div class="flex items-center py-5 text-base border-b border-gray-300" style="background-color: #faf9f9">
        <span class="mr-1">当前位置：</span>
        <NBreadcrumb>
          <NBreadcrumbItem @click="gotoHome">首页</NBreadcrumbItem>
          <NBreadcrumbItem>实训平台</NBreadcrumbItem>
        </NBreadcrumb>
      </div>
      <img class="carousel-img" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/banner5.png" />
      <div class="flex items-center my-4 zhu_yi">
        <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/news.png" alt="" />
        <span class="mx-2 text-base font-bold">注意事项：</span>
        <span style="color: #f70707">
          实训平台是独立的实训系统，学员账号默认不开通实训平台的课程和实训，如需学习和实训请联系服务人员进行开通。
        </span>
      </div>
      <div class="mt-10" style="text-indent: 2em">
        <p>
          按照实际公司的组织结构和商业逻辑模拟公司运营，学员通过模拟组建公司、确定公司架构、分析经营环境、尝试
          经营业务和完成各项岗位工作任务等来提自身的社会能力、办公能力和业务能力，体验真实商业环境和商业行为。
        </p>
        <p class="mt-1">
          从而增强其参与市场竞争和驾驭市场的应变能力，降低创业风险，提高开业成功率和提升经营稳定率。
        </p>
        <p class="mt-10" style="color: #f70707">
          以“试创业”的方式让学员在模拟商业环境中，培养学员经营管理能力，了解创业过程,实训平
          台包含以下功能。
        </p>
      </div>
      <div style="margin-top: 100px">
        <div class="flex items-center">
          <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon5-1.png" alt="" />
          <div class="ml-10">
            <p class="text-2xl" style="color: #f70707">体验企业创立</p>
            <p class="mt-3">
              真实模拟创建企业所需的各个环节，让学员了解创建企业成立过程及关键环节。
            </p>
          </div>
        </div>
        <img class="mt-8 w-full" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line5.png" alt="" />
      </div>
      <div class="mt-8">
        <div class="flex items-center">
          <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon5-2.png" alt="" />
          <div class="ml-10">
            <p class="text-2xl" style="color: #f70707"> 模拟真实商业环境 </p>
            <p class="mt-3">系统根据创建企业的各项信息，模拟真实商业环境，增加学员实训体验。 </p>
          </div>
        </div>
        <img class="mt-8 w-full" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line5.png" alt="" />
      </div>
      <div class="mt-8">
        <div class="flex items-center">
          <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon5-2.png" alt="" />
          <div class="ml-10">
            <p class="text-2xl" style="color: #f70707">公司运营实训</p>
            <p class="mt-3">过让学员维护进货数量、人员招聘、商品定价、企业选址等信息，让学员体验企业运营过程，增强学员企业
              经营管理的决策思维。
            </p>
          </div>
        </div>
        <img class="mt-8 w-full" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line5.png" alt="" />
      </div>
      <div class="mt-8">
        <div class="flex items-center">
          <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon5-2.png" alt="" />
          <div class="ml-10">
            <p class="text-2xl" style="color: #f70707">经营结果分析 </p>
            <p class="mt-3">根据学员模拟运营结果，出具经营结果分析，让学员了解模拟经营管理过程中存在的问题，以便更好理解
              运营过程。
            </p>
          </div>
        </div>
        <img class="mt-8 w-full" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line5.png" alt="" />
      </div>
      <div class="mt-8">
        <div class="flex items-center">
          <img src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/icon5-2.png" alt="" />
          <div class="ml-10">
            <p class="text-2xl" style="color: #f70707"> 体验运营风险 </p>
            <p class="mt-3">
              通过企业经营、商业竞争的模拟训练，让学员体验企业运营风险，增强学员参与市场竞争和驾驭市场的应
              变能力，降低创业风险。
            </p>
          </div>
        </div>
        <img class="mt-8 w-full" src="https://qingjuck.oss-cn-shanghai.aliyuncs.com/qjsite/img/img/line5.png" alt="" />
      </div>
    </div>
  </Layout>
</template>

<script setup>
import Layout from '@/components/Layout';
import { useRouter } from 'vue-router';

const router = useRouter();
function gotoHome () {
  router.push('/');
}
</script>

<style lang="scss" scoped>
.carousel-img {
  display: block;
  width: 100%;
  height: 410px;
  object-fit: cover;
}
:deep(.n-breadcrumb-item) {
  font-size: 16px;
}

.zhu_yi {
  border: 1px dashed #f39a1d;
  height: 60px;
  font-size: 20px;
}
</style>
